
import { Component, Vue } from 'vue-property-decorator';
import UtilsService from '@/services/utils.service';
import GAService from '@/services/ga.service';
import StackedBarChart from '@/components/StackedBarChart.vue';
import _ from 'lodash';

@Component({
  components: {
    StackedBarChart
  },
})
export default class ChartCol extends Vue {
  public downloading: boolean = false;
  public showAllAttributes: boolean = false;
  get calculating() {
    return this.$store.state.results.calculating;
  }

  get result() {
    return this.$store.state.results.result || {};
  }

  get profileShowingOnGraph() {
    return this.$store.state.profiles.profileShowingOnGraph || {};
  }

  get selectedGraphIndex() {
    return this.$store.state.results.selectedGraphIndex || 0;
  }

  public get attributesDisplayMap() {
    return this.$store.state.options.attributesDisplayMap || {};
  }

  public setSelectedGraphIndex(index: number) {
    this.$store.commit('setSelectedGraphIndex', index);
    this.$store.commit('triggerClearGraphStickyColumns');
  }

  public getPassRate(res: any) {
    if (_.isEmpty(res)) {
      return '-';
    }

    return UtilsService.round((res.pass / (res.pass + res.fail)) * 100);
  }

  public async download() {
    this.downloading = true;
    try {
      GAService.sendEvent(this.$gtag, 'Download', '', '');
      const res = await this.$store.dispatch('downloadResults');
      UtilsService.exportCSVFile(res, this.profileShowingOnGraph && this.profileShowingOnGraph.name ?  this.profileShowingOnGraph.name : 'Untitled Profile');
    } catch (e) {
      console.log('error handled in store');
    }
    this.downloading = false;
  }
}
